import { sendAsyncMetric } from '.';
import { requestIdleInterval, isDomFocus } from "../../utils";
export var startMemory = function startMemory(taskRef) {
  var _taskRef$value;
  var _ref = ((_taskRef$value = taskRef.value) === null || _taskRef$value === void 0 ? void 0 : _taskRef$value.ctx) || {},
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options;
  var memoryInterval = options.memoryInterval;
  // 
  requestIdleInterval(function () {
    var _performance$memory, _performance$memory2, _performance$memory3;
    var usedJSHeapSize = (_performance$memory = performance.memory) === null || _performance$memory === void 0 ? void 0 : _performance$memory.usedJSHeapSize;
    var jsHeapSizeLimit = (_performance$memory2 = performance.memory) === null || _performance$memory2 === void 0 ? void 0 : _performance$memory2.jsHeapSizeLimit;
    var totalJSHeapSize = (_performance$memory3 = performance.memory) === null || _performance$memory3 === void 0 ? void 0 : _performance$memory3.totalJSHeapSize;
    if (usedJSHeapSize === undefined) return;
    var value = "".concat(parseInt(usedJSHeapSize), "|").concat(parseInt(jsHeapSizeLimit), "|").concat(parseInt(totalJSHeapSize));
    if (value === undefined || !isDomFocus()) return;
    var type = 'memory';
    console.log('[Measurements] memory', value);
    var val = "".concat(Date.now(), "|").concat(value);
    sendAsyncMetric(taskRef.value, {
      type: type,
      value: val
    });
  }, memoryInterval);
};